module.exports = __webpack_public_path__ + "static/media/PermissionsandControls.1634b6bc.jpg";